export default "__VITE_ASSET__CdXVsljx__"